import React, { useState, useRef, useEffect, useContext } from 'react'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import CustomInput from '../../atoms/Inputs/CustomInput'
import PrimaryButton from '../../atoms/PrimaryButton'
import SecondaryButton from '../../atoms/SecondaryButton'
import './ProductCard.css'
import FavouriteCheckbox from '../../atoms/FavoriteCheckbox'
import Popup from '../../organisms/Popup'
import Timer from '../../../common/timer'
import AddDispute from './AddDispute'
import Bidding from '../../molecules/Bidding/BiddingItem'
import { dateFormatFront } from '../../../common/components'
import { handleRedirectInternal, currencyFormat } from '../../../common/components'
import CommonContext from '../../../context/common/commonContext'
import AuthContext from '../../../context/auth/authContext'
import { Link } from 'react-router-dom'

const ListView = (props) => {
    const [addCard, setAddCard] = React.useState(false)
    const product = props.data
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)

    const { isAuthenticated, user } = authContext
    const { setBidHistoryValue, phrase } = commonContext
    const [disputePopup, setDisputePopup] = useState(false)

    const history = useHistory()
    const resolvedAuctionFormat = product?.auction_format || props.fallbackAuctionFormat
    const productViewPath = resolvedAuctionFormat
        ? `/product/view/${product.id}?af=${resolvedAuctionFormat}`
        : `/product/view/${product.id}`
    const isOutletAuction = resolvedAuctionFormat === 'outlet'

    const openDisputePopup = () => {
        setDisputePopup(true)
    }
    const closeDisputePopup = () => {
        setDisputePopup(false)
    }

    let dashboardLink = null
    if (props.dashboard && product) {
        if (props.dashboardType == 'won' || props.dashboardType == 'buy_now') {
            dashboardLink = (
                <div>
                    <div className="mb-1">
                        <Link to={`/invoice/${product.invoice_id}`}>
                            <PrimaryButton label={phrase.view + ' ' + phrase.order} />
                        </Link>
                    </div>
                    <div>
                        <PrimaryButton
                            onClick={() => openDisputePopup()}
                            label={phrase.add + ' ' + phrase.dispute}
                        />
                        <AddDispute
                            open={disputePopup}
                            product={product}
                            openDisputePopup={() => openDisputePopup()}
                            closeDisputePopup={() => closeDisputePopup()}
                        />
                    </div>
                </div>
            )
        } else if (props.dashboardType == 'active' || props.dashboardType == 'watchlist') {
            dashboardLink = (
                <Link to={productViewPath}>
                    <PrimaryButton label={phrase.view} />
                </Link>
            )
        }
    }

    let categories = ''
    if (product) {
        for (let i in product.multiplecategoryshow) {
            if (i == product.multiplecategoryshow.length - 1) {
                // last index
                //categories += product.multiplecategoryshow[i]
                categories += phrase[product.multiplecategoryshow[i]]
            } else {
                //categories += product.multiplecategoryshow[i] + ', '
                categories += phrase[product.multiplecategoryshow[i]] + ','
            }
        }
    }

    return (
        <>
            <div
                className={`productCardList d-flex justify-content-between align-items-start ${
                    isOutletAuction ? 'outlet' : ''
                }`}
            >
                <div className="psListLt d-flex">
                    <div className="pclImg">
                        <Link to={productViewPath}>
                            <img
                                src={
                                    global.site_url +
                                    '/uploads/product/compressed/' +
                                    product.avatar
                                }
                                alt={product.title}
                            />
                        </Link>
                        {props.completed && <h4 className="aucEnded">Auction Ended</h4>}
                        {(props.dashboard &&
                            props.dashboardType != 'watchlist' &&
                            props.dashboardType != 'active') ||
                        props.completed ? null : user.isBuyer ? (
                            <FavouriteCheckbox
                                watchlisted={product.watchlistid}
                                project_id={product.id}
                                isDashboard={props.dashboard}
                            />
                        ) : null}
                        <div className="listBidStatus">
                            {isAuthenticated && (
                                <>
                                    {product.bidtopstatus === 'outbid' && (
                                        <h4 className="productWinningStatus outbid">OUTBID</h4>
                                    )}
                                    {product.bidtopstatus === 'winner' && (
                                        <h4 className="productWinningStatus winning">WINNING</h4>
                                    )}
                                    {product.bidtopstatus === 'won' && (
                                        <h4 className="productWinningStatus won">WON</h4>
                                    )}
                                    {product.bidtopstatus === 'lost' && (
                                        <h4 className="productWinningStatus lost">LOST</h4>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    <div className="listContent ">
                        <h2 className="listProdTitle">
                            <Link to={productViewPath}>{product.title}</Link>
                        </h2>

                        <div className="listLotDetails">
                            <div className="gridLotDetails">
                                <p>
                                    <label>{phrase.manufacturer}</label>
                                    {product.manufacturer}
                                </p>
                                <p>
                                    <label>{phrase.model}</label>
                                    {product.modelnumber}
                                </p>
                            </div>
                            <div className="gridLotDetails">
                                <p>
                                    <label>{phrase.category}</label>
                                    {categories}
                                </p>
                                <p>
                                    <label>{phrase.size}</label>
                                    {product.size}
                                </p>
                            </div>
                            <div className="gridLotDetails">
                                <p>
                                    <label>{phrase.condition}</label>
                                    {phrase[product.condition_language]}
                                </p>
                                <p>
                                    <label>{phrase.quantity}</label>
                                    {`${product.qty}`}
                                </p>
                            </div>
                            <div className="gridLotDetails fr1">
                                <p>
                                    <label>{phrase.location}</label>
                                    {`${product.country}`}
                                    {/* {`${product.city}, ${product.state}, ${product.country}`} */}
                                </p>
                            </div>
                            {/* Commented out fields */}
                            {/*
                            <div className="gridLotDetails">
                                <p>
                                    <label> UPC/SKU </label>
                                    {product.upc}
                                </p>
                            </div>
                            <div className="gridLotDetails">
                                <p>
                                    <label> {phrase.lot_size} </label>
                                    {`${phrase[product.lottype]} ${phrase.lot}`}
                                </p>
                                <p>
                                    <label> {phrase.auction_type} </label>
                                    {product.auctiontype == 'live'
                                        ? phrase.live_auction
                                        : product.auctiontype == 'lineitem'
                                        ? phrase.line_item_auction
                                        : phrase.blind_auction}
                                </p>
                            </div>
                            <div className="gridLotDetails">
                                <p>
                                    <label>{phrase.finish}</label>
                                    {product.finish}
                                </p>
                            </div>
                            */}
                        </div>

                        <div className="d-flex justify-content-between flex-wrap">
                            {product.market_status === 'open' && !props.completed ? (
                                product.auctiontype !== 'lineitem' ? (
                                    <>
                                        {product.auctiontype == 'live' ? (
                                            <div className="listBidInfo d-flex justify-content-between align-items-center">
                                                <h6>
                                                    {product.latestbid
                                                        ? phrase.current_bid
                                                        : phrase.starting_price}
                                                    :
                                                </h6>
                                                <p>
                                                    <span>
                                                        {product.wprice} {product.currency}
                                                    </span>
                                                </p>
                                                <p>
                                                    <span>
                                                        {(
                                                            parseFloat(
                                                                `${product.wprice}`.replaceAll(
                                                                    ',',
                                                                    '',
                                                                ),
                                                            ) / parseInt(product.qty)
                                                        ).toFixed(2)}{' '}
                                                        {product.currency} / Unit
                                                    </span>
                                                </p>
                                            </div>
                                        ) : null}

                                        <div className="listBidInfo d-flex justify-content-between align-items-center">
                                            {product.market_status == 'open' ? (
                                                <>
                                                    <h6>{phrase.time_left}:</h6>
                                                    <p className="d-flex align-items-center">
                                                        {product.date_closed ? (
                                                            <Timer
                                                                date_added={product.date_added}
                                                                date_closed={product.date_closed}
                                                                withText={0}
                                                            ></Timer>
                                                        ) : null}
                                                    </p>
                                                </>
                                            ) : null}
                                        </div>
                                    </>
                                ) : (
                                    <div className="listBidInfo d-flex justify-content-between align-items-center">
                                        {product.market_status == 'open' ? (
                                            <>
                                                <h6>{phrase.time_left}:</h6>
                                                <p className="d-flex align-items-center">
                                                    {product.date_closed ? (
                                                        <Timer
                                                            date_added={product.date_added}
                                                            date_closed={product.date_closed}
                                                            withText={0}
                                                        ></Timer>
                                                    ) : null}
                                                </p>
                                            </>
                                        ) : null}
                                    </div>
                                )
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className={`listActBtn ${props.completed && 'ended'}`}>
                    {props.dashboard ? (
                        dashboardLink
                    ) : (
                        <Link to={productViewPath}>
                            <PrimaryButton
                                label={phrase.view}
                                btnSize="small"
                                isOutlet={props.isOutlet}
                            />
                        </Link>
                    )}
                </div>
            </div>
        </>
    )
}
export default ListView
